import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Box, Grid } from '@material-ui/core';
import { ListAlt } from '@material-ui/icons';
import moment from 'moment';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  setDownloadConditionFlg,
  checkDownloadStatus,
  fileDownloadExecute,
  startDownloadPolling,
  stopDownloadPolling,
} from '../../actions/CompanyAction';
import {
  PROCESS_STATUS,
  DOWNLOAD_STATUS_MESSAGE,
  DOWNLOAD_DISP_STATUS,
  DATE_TIME_FORMAT,
  TRIAL_FLG,
} from '../../../common/const';
import { getMessage } from '../../../common/util';
import styles from './CompanyDownloadStatusComponent.module.css';
import MyIcon from '../common/MyIcon';

class CompanyDownloadStatusComponent extends Component {
  async componentDidMount() {
    const {
      checkDownloadStatusAct,
      startDownloadPollingAct,
    } = this.props;
    // ダウンロードステータス情報取得
    const ret = await checkDownloadStatusAct();
    // ダウンロードステータスが処理中の場合、ポーリング処理を開始
    if (ret) {
      await startDownloadPollingAct();
    }
  }

  componentWillUnmount() {
    const { stopDownloadPollingAct } = this.props;
    // ポーリング処理を停止
    stopDownloadPollingAct();
  }

  onClickFileDownloadExecute = async () => {
    const {
      fileDownloadExecuteAct,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ファイルダウンロード
    await fileDownloadExecuteAct();
    setSystemLodingFLgAct(false);
  }

  setDownloadConditionFlg = async () => {
    const { setDownloadConditionFlgAct } = this.props;
    setDownloadConditionFlgAct(true);
  }

  render() {
    const { downloadStatusInfo, companyHierarchyInfoList, userInfo } = this.props;
    let createDateMessage = null;
    let downloadStatusMessage = null;

    // ダウンロードステータス表示判定
    if (downloadStatusInfo.status
      && DOWNLOAD_DISP_STATUS.includes(downloadStatusInfo.status)) {
      // ファイル作成日付の文言作成
      createDateMessage = downloadStatusInfo.create_datetime
        ? `${moment(
          downloadStatusInfo.create_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
        ).format(DATE_TIME_FORMAT.DATE_TIME)} 作成分`
        : null;

      // ダウンロードステータスに応じた文言を作成
      if (downloadStatusInfo.status === PROCESS_STATUS.PROCESSING) {
        // 処理中
        downloadStatusMessage = !Number.isNaN(Number(downloadStatusInfo.read_count))
          ? getMessage(DOWNLOAD_STATUS_MESSAGE.PROCESSING,
            Number(downloadStatusInfo.read_count).toLocaleString())
          : null;
      } else if (downloadStatusInfo.status === PROCESS_STATUS.INTERRUPT) {
        // 中断
        downloadStatusMessage = DOWNLOAD_STATUS_MESSAGE.INTERRUPT;
      } else if (downloadStatusInfo.status === PROCESS_STATUS.ANOMALY) {
        // 異常終了
        downloadStatusMessage = DOWNLOAD_STATUS_MESSAGE.ANOMALY;
      }
    }

    return (
      <Box className={`${styles.companyDownloadList}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.button}`}>
            {downloadStatusInfo.status === PROCESS_STATUS.SUCCESS_OK
              && (
              <Box className={`${styles.balloon1} balloon-bottom`}>
                <Box className={`${styles.bubble} bubble`}>
                  {createDateMessage}
                  <br />
                  {DOWNLOAD_STATUS_MESSAGE.SUCCESS_OK}
                </Box>
                <Box className={`${styles.triangle} triangle`}>
                  <Box />
                </Box>
              </Box>
              )}
            <Box className={`${styles.buttonfield}`}>
              {downloadStatusInfo.status !== PROCESS_STATUS.SUCCESS_OK
                && createDateMessage
                && downloadStatusMessage
                && (
                  <Box className={`${styles.downloadStatus}`}>
                    <span className={`${styles.message}`}>{createDateMessage}</span>
                    <span className={`${styles.message}`}>{downloadStatusMessage}</span>
                  </Box>
                )}
              {/* ダウンロードステータスが正常終了の場合、ファイルダウンロードボタンを表示 */}
              {downloadStatusInfo.status === PROCESS_STATUS.SUCCESS_OK
                && (
                  <Box>
                    <Grid container className={`${styles.downloadbutton}`}>
                      <Button
                        variant="contained"
                        color="secondary"
                        className={`${styles.filedownload} ${styles.tooltip} tooltip`}
                        onClick={() => this.onClickFileDownloadExecute(this)}
                        startIcon={<MyIcon className={`${styles.faceIcon}`} type="download" />}
                      />
                      {!companyHierarchyInfoList.kigyo_code
                        && (
                        <span className={`${styles.space}`} />
                        )}
                    </Grid>
                  </Box>
                )}
            </Box>
            {/* ダウンロードステータスが処理中以外かつ企業が選択されている場合、ダウンロードリクエストボタンを表示 */}
            {downloadStatusInfo.status !== PROCESS_STATUS.PROCESSING
              && companyHierarchyInfoList.kigyo_code
              && (
                <Box>
                  {downloadStatusInfo.status === PROCESS_STATUS.SUCCESS_OK
                    && (
                      <Box className={`${styles.balloon2} balloon-bottom`}>
                        <Box className={`${styles.bubble} bubble`}>
                          最新検索結果で
                          <br />
                          ファイル再作成
                        </Box>
                        <Box className={`${styles.triangle} triangle`}>
                          <Box />
                        </Box>
                      </Box>
                    )}
                  <Button
                    variant="contained"
                    color="secondary"
                    className={userInfo.trial_flag === TRIAL_FLG.ON || downloadStatusInfo.status === PROCESS_STATUS.SUCCESS_OK ? 'cancel' : null}
                    startIcon={<ListAlt />}
                    onClick={() => (
                      userInfo.trial_flag === TRIAL_FLG.OFF
                        ? this.setDownloadConditionFlg(this) : null
                    )}
                  >
                    ダウンロードリクエスト
                  </Button>
                </Box>
              )}
          </Box>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    downloadStatusInfo: state.company.downloadStatusInfo,
    companyHierarchyInfoList: state.company.companyHierarchyInfoList,
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    checkDownloadStatusAct: () => dispatch(checkDownloadStatus()),
    setDownloadConditionFlgAct: (bool) => dispatch(setDownloadConditionFlg(bool)),
    fileDownloadExecuteAct: () => dispatch(fileDownloadExecute()),
    startDownloadPollingAct: () => dispatch(startDownloadPolling()),
    stopDownloadPollingAct: () => dispatch(stopDownloadPolling()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(CompanyDownloadStatusComponent);
